var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "subscription-upgrade-yearly-monthly-card" } },
    [
      _vm.apparatusesToAdd &&
      _vm.apparatusesToAdd.length &&
      _vm.subscriptionProduct
        ? _c(
            "b-card",
            {
              staticClass: "paid-subs-info-card mb-0 sub-card mx-1",
              attrs: {
                "body-class": "subs-info-card-body",
                "data-test-hook": "existing-subscription-modal-paid-card"
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header",
                    fn: function() {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "plan-header",
                            attrs: {
                              "data-test-hook":
                                "subscription-upgrade-yearly-monthly-card-header"
                            }
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.subscriptionProduct[0].name) +
                                " "
                            )
                          ]
                        )
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                619502550
              )
            },
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-button",
                        {
                          class: _vm.getSplitButtonClass(),
                          attrs: {
                            variant:
                              _vm.planChoice === "yearly"
                                ? "primary"
                                : "secondary",
                            "data-test-hook":
                              "upgrade-to-multi-home-modal-button-continue"
                          },
                          on: {
                            click: function($event) {
                              _vm.planChoice =
                                _vm.planChoice === "yearly"
                                  ? "monthly"
                                  : "yearly"
                            }
                          }
                        },
                        [
                          _vm.planChoice === "yearly"
                            ? _c("div", [
                                _c("i", { staticClass: "far fa-check" }),
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.$t("xBilledAnnually")) +
                                    "               "
                                ),
                                _c(
                                  "span",
                                  { staticStyle: { color: "black" } },
                                  [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("xBilledMonthly"))
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm.planChoice === "monthly"
                            ? _c("div", [
                                _c(
                                  "span",
                                  { staticStyle: { color: "black" } },
                                  [_vm._v(_vm._s(_vm.$t("xBilledAnnually")))]
                                ),
                                _vm._v("                "),
                                _c(
                                  "span",
                                  { staticStyle: { color: "white" } },
                                  [
                                    _c("i", { staticClass: "far fa-check" }),
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("xBilledMonthly"))
                                    )
                                  ]
                                )
                              ])
                            : _vm._e()
                        ]
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _vm.planChoice === "yearly"
                    ? _c(
                        "b-row",
                        { staticClass: "align-items-center mb-2 mx-0 mt-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "col-0 px-0 text-center" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "mb-0 pb-0",
                                  attrs: {
                                    "data-test-hook":
                                      "subscription-card-cost-yearly"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "price",
                                      staticStyle: {
                                        "font-size": "1.75rem",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            _vm.subscriptionProduct[1]?.cost
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "yearly ml-1",
                                  staticStyle: { "font-weight": "bold" }
                                },
                                [
                                  _vm._v(
                                    "/" + _vm._s(_vm.$t("xYear").toLowerCase())
                                  )
                                ]
                              ),
                              _vm._v("  "),
                              _c(
                                "b-badge",
                                {
                                  staticClass: "plan-badge text-right",
                                  staticStyle: { "vertical-align": "super" },
                                  attrs: { variant: "primary" }
                                },
                                [_vm._v(_vm._s(_vm.$t("xSavePercent")))]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.planChoice === "monthly"
                    ? _c(
                        "b-row",
                        { staticClass: "align-items-center mb-2 mx-0 mt-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "col-0 px-0 text-center" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "mb-0 pb-0",
                                  attrs: {
                                    "data-test-hook":
                                      "subscription-card-cost-yearly"
                                  }
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "price",
                                      staticStyle: {
                                        "font-size": "1.75rem",
                                        "font-weight": "bold"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            _vm.subscriptionProduct[0]?.cost
                                          )
                                        )
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "yearly ml-1",
                                  staticStyle: { "font-weight": "bold" }
                                },
                                [
                                  _vm._v(
                                    "/" + _vm._s(_vm.$t("xMonth").toLowerCase())
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.planChoice === "monthlyold"
                    ? _c(
                        "b-row",
                        { staticClass: "align-items-center mb-2 mx-0 mt-3" },
                        [
                          _c(
                            "b-col",
                            { staticClass: "col-7 px-0 text-right" },
                            [
                              _c("div", [
                                _c(
                                  "h1",
                                  {
                                    staticClass: "mb-0 pb-0",
                                    attrs: {
                                      "data-test-hook":
                                        "upgrade-subscription-card-cost"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            _vm.subscriptionProduct[0]?.cost
                                          )
                                        ) +
                                        " "
                                    ),
                                    _c("span", { staticClass: "monthly" }, [
                                      _vm._v(
                                        "/" +
                                          _vm._s(_vm.$t("xMonth").toLowerCase())
                                      )
                                    ])
                                  ]
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "subscriptionCardText mt-3" },
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", [
                        _vm.subscriptionProduct[0] &&
                        _vm.subscriptionProduct[0].description
                          ? _c(
                              "strong",
                              {
                                attrs: {
                                  "data-test-hook":
                                    "existing-subscription-modal-premium-monitoring-max-products-text"
                                }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.subscriptionProduct[0].description
                                    ) +
                                    " "
                                )
                              ]
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _vm._l(_vm.apparatusesToUpgrade, function(apparatus, index) {
                    return _c(
                      "b-row",
                      { key: index },
                      [
                        _c("b-col", { staticClass: "mt-2" }, [
                          _c("div", { staticClass: "d-flex" }, [
                            _c("i", {
                              staticClass:
                                "fas fa-fw fa-check-circle check-icon mr-2"
                            }),
                            _c("p", [_vm._v(_vm._s(apparatus.name))])
                          ])
                        ])
                      ],
                      1
                    )
                  }),
                  _vm._l(_vm.apparatusesToAdd, function(apparatus, index) {
                    return _c(
                      "b-row",
                      { key: index },
                      [
                        apparatus.type === 0 || apparatus.apparatusType === 0
                          ? _c("ExpandableHsbSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${
                                  _vm.isNewPlan ? "current" : "new"
                                }`,
                                "generator-name": apparatus.name,
                                "is-covered": _vm.isNewPlan
                              }
                            })
                          : apparatus.type === 2 ||
                            apparatus.apparatusType === 2
                          ? _c("ExpandableTankSubscriptionFeaturesList", {
                              attrs: {
                                id: `${apparatus.apparatusId}-${
                                  _vm.isNewPlan ? "current" : "new"
                                }`,
                                "tank-name": apparatus.name,
                                "is-covered": _vm.isNewPlan
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }